import ApiServiceBase from '@/services/ApiServiceBase'
import jiff from 'jiff'

const getDefaultState = () => {
    return {
        all: []
    }
}

export const SETTING_KEYS = {
    EmailOptIn_Enabled: "EmailOptIn_Enabled",
    EmailOptIn_AllowedFromDomains: "EmailOptIn_AllowedFromDomains",
    EmailOptIn_OptInEmailAddress: "EmailOptIn_OptInEmailAddress"
}

export const namespaced = true

export const state = getDefaultState()

export const mutations = {
    SET_SETTINGS_LIST (state, settings) {
        state.all = settings
    },

    UPDATE_LIST_SETTING (state, addOrUpdSetting) {
        const index = state.all.findIndex(u => u.key === addOrUpdSetting.key)
        if (index === -1) {
            state.all.push(addOrUpdSetting)
        } else {
            state.all.splice(index, 1, addOrUpdSetting)
        }
    },
    RESET_STATE (state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultState())
    }
}

export const actions = {
    loadSettings ({ commit }) {
        return ApiServiceBase.find({
            resource: 'system/setting',
            query: null
        }).then(response => {
            commit('SET_SETTINGS_LIST', response.data)
        })
    },
    updateSetting ({ commit, state }, updSetting) {
        const existing = state.all.find(u => u.key === updSetting.key)

        // Simplified update model
        const simplified = {
            key: existing.key,
            value: existing.value,
            devValue: existing.devValue
        }

        // Let's not remove any values
        if (!("value" in updSetting)) {
            updSetting["value"] = simplified.value
        }
        if (!("devValue" in updSetting)) {
            updSetting["devValue"] = simplified.devValue
        }

        // Values must be strings
        updSetting.value = updSetting.value.toString()
        updSetting.devValue = updSetting.devValue.toString()

        const patch = jiff.diff(simplified, updSetting, {
            hash: JSON.stringify,
            makeContext: null
        })

        if (!patch.length) {
            // Nothing changed
            return Promise.resolve()
        }

        return ApiServiceBase.update({
            resource: 'system/setting',
            id: updSetting.key,
            data: patch,
            query: null
        }).then(response => {
            commit('UPDATE_LIST_SETTING', response.data)
            return response
        })
    }
}

export const getters = {
    visibleSettings(state) {
        return state.all.filter(s => s.isVisible)
    }
}

export function getEmailOptInSettings () {
    return new Promise((resolve, reject) => {
        return ApiServiceBase.find({
            resource: 'system/setting/emailoptin',
            query: null
        }).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}